import React from 'react';
import PropTypes from 'prop-types';

export function TextCell(props) {
  return (
    <td className={props.className}>
      <p>{props.text}</p>
    </td>
  );
}

TextCell.propTypes = {
  /**
   * Text to be displayed on the cell
   */
  text: PropTypes.string,
  /**
   * className to be set on the cell
   */
  className: PropTypes.string,
};
